/**
 * Dietary Filter Chips Component
 * Chips: Vegetarian 🌿 | Spicy 🌶 | Gluten-free 🌾
 * Hides categories with no matching items when active.
 */

import { getCurrentLanguage } from '../../../i18n';
import type { DietTag } from '../types';

export type ActiveFilters = Set<DietTag>;

const LABELS: Record<string, Record<DietTag, string>> = {
  th: { veg: '🌿 มังสวิรัติ', spicy: '🌶 เผ็ด', gf: '🌾 ไม่มีกลูเตน' },
  en: { veg: '🌿 Vegetarian', spicy: '🌶 Spicy', gf: '🌾 Gluten-free' },
  zh: { veg: '🌿 素食', spicy: '🌶 辣', gf: '🌾 无麸质' },
  ru: { veg: '🌿 Вегетарианское', spicy: '🌶 Острое', gf: '🌾 Без глютена' },
  ja: { veg: '🌿 ベジタリアン', spicy: '🌶 辛口', gf: '🌾 グルテンフリー' },
  ko: { veg: '🌿 채식', spicy: '🌶 매운 맛', gf: '🌾 글루텐 프리' },
};

const TAGS: DietTag[] = ['veg', 'spicy', 'gf'];

export function renderDietFilter(active: ActiveFilters): string {
  const lang = getCurrentLanguage();
  const labels = LABELS[lang] || LABELS.en;

  const chips = TAGS.map((tag) => {
    const isOn = active.has(tag);
    return `
      <button
        class="diet-chip${isOn ? ' diet-chip--on' : ''}"
        onclick="window.toggleDietFilter?.('${tag}')"
        aria-pressed="${isOn}"
        data-tag="${tag}"
        style="
          display:inline-flex;align-items:center;gap:4px;
          padding:7px 13px;border-radius:20px;border:1.5px solid ${isOn ? '#00B900' : '#e0e0e0'};
          background:${isOn ? '#E8F5E8' : '#fff'};
          color:${isOn ? '#00B900' : '#555'};
          font-size:13px;font-weight:${isOn ? '600' : '400'};
          cursor:pointer;white-space:nowrap;
          transition:all 0.15s ease;
          touch-action:manipulation;
        "
      >${labels[tag]}</button>
    `;
  }).join('');

  return `
    <div id="diet-filter-strip" style="
      display:flex;gap:8px;overflow-x:auto;-webkit-overflow-scrolling:touch;
      padding:0 0 4px;margin-bottom:12px;scrollbar-width:none;
    ">${chips}</div>
  `;
}

/** Update chip UI in-place without full re-render */
export function updateDietChipUI(tag: DietTag, isOn: boolean): void {
  const btn = document.querySelector<HTMLButtonElement>(`.diet-chip[data-tag="${tag}"]`);
  if (!btn) return;
  btn.classList.toggle('diet-chip--on', isOn);
  btn.setAttribute('aria-pressed', String(isOn));
  btn.style.borderColor = isOn ? '#00B900' : '#e0e0e0';
  btn.style.background = isOn ? '#E8F5E8' : '#fff';
  btn.style.color = isOn ? '#00B900' : '#555';
  btn.style.fontWeight = isOn ? '600' : '400';
}
